export default __webpack_public_path__ + "static/media/tinder.b0ef898c.png";